import { Box, Button, TextButton, TextInput } from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import React, { useEffect, useState } from "react";
import { Stack } from "@strapi/design-system/Stack";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Sidebar from "./layout/Sidebar";

const ChangePassword = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const loginUser = localStorage.getItem("user");
    if (loginUser) {
      setUser(JSON.parse(loginUser));
    }
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const handleLogout = () => {
    localStorage.clear();

    if (lng === "en") navigate(`/nomination/login`);
    else navigate(`/nomination/dang-nhap`);
  };
  return (
    <div>
      <div>
        <Stack padding={4} spacing={4} horizontal>
          <Button variant="default">
            {t("str_welcome")}, {user?.email}
          </Button>
          <TextButton onClick={handleLogout}>{t("str_logout")}</TextButton>
        </Stack>
        <br />
        <div className="main-wrapper">
          <Sidebar role={{ type: "" }} key={"change_password"} />

          <div className="main-panel-lg">
            <Box padding={4}>
              <Grid gridCols={3} gap={5}>
                <GridItem col={1} s={12} xs={12}>
                  <TextInput
                    value={currentPassword}
                    name="old_password"
                    label={t("str_current_password")}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                </GridItem>
                <GridItem col={2} s={0} xs={0}></GridItem>
                <GridItem col={1} s={12} xs={12}>
                  <TextInput
                    value={newPassword}
                    name="old_password"
                    label={t("str_new_password")}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </GridItem>
                <GridItem col={2} s={0} xs={0}></GridItem>
                <GridItem col={1} s={12} xs={12}>
                  <TextInput
                    value={confirmNewPassword}
                    name="old_password"
                    label={t("str_confirm_password")}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                  />
                </GridItem>
                <GridItem col={2} s={0} xs={0}></GridItem>
                <GridItem col={1} s={12} xs={12}>
                  <Button>{t("str_confirm")}</Button>
                </GridItem>
              </Grid>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
